import { KeyFunctionMap, RxCollection, RxCollectionCreator, RxJsonSchema } from "rxdb"
import { UnsubmittedWorkIssue } from "src/util/types/dataModels/unsubmittedWork"

//region Types

export type UnsubmittedWorkIssueCollection = RxCollection<UnsubmittedWorkIssue, KeyFunctionMap>

//endregion

/**
 * Schema for unsubmitted work collections
 */
export const unsubmittedWorkIssueSchema: RxJsonSchema<UnsubmittedWorkIssue> = {
  title: "Unsubmitted work issues schema",
  description: "Collection of all the unsubmitted work issues",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true }, // UUID
    unsubmitted_work_id: { type: "string", maxLength: 36, uniqueItems: true }, // UUID
    issue: { type: "object" },
    action: { type: "object" },
  },
  required: ["id", "unsubmitted_work_id", "issue"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const unsubmittedWorkIssueCollectionCreator: RxCollectionCreator = {
  schema: unsubmittedWorkIssueSchema,
}
